import React, { useEffect, useState } from "react";
import { Helmet } from "react-helmet";
import classNames from "classnames";

import PageTitle from "../../common/PageTitle";
import { Link, useLocation } from "react-router-dom";
import Icons from "./sub/Icons";
import Forecasts from "./sub/Forecasts";
import Alerts from "./sub/Alerts";
import MarketData from "./sub/MarketData";

const MarketInfoPage = () => {
  const [tab, setTab] = useState("");
  const location = useLocation();

  useEffect(() => {
    const searchParams = new URLSearchParams(location.search);
    const t = searchParams.get("tab");
    if (t === "forecasts") {
      setTab("forecasts");
    } else if (t === "alert") {
      setTab("alert");
    } else {
      setTab("price-change");
    }
  }, [location.search]);

  return (
    <>
      <Helmet>
        <title>Turgoil - Turuinfo</title>
        <meta
          name="viewport"
          content="width=device-width, initial-scale=1.0, user-scalable=no"
        />
      </Helmet>
      <PageTitle>Turuinfo</PageTitle>

      <div className="market-info">
        <div className="market-info__navigation">
          <ul>
            <li>
              <Link
                className={classNames("market-info__navigation-link", {
                  "market-info__navigation-link--active":
                    tab === "price-change",
                })}
                to="?tab=price-change"
              >
                {tab === "price-change" ? (
                  <div>{Icons.PriceChangeYellow}</div>
                ) : (
                  <div>{Icons.PriceChangeBlack}</div>
                )}
                Turu andmed
              </Link>
            </li>
            {/* <li> */}
            {/*     <Link */}
            {/*         className={classNames("market-info__navigation-link", { */}
            {/*             "market-info__navigation-link--active": tab === "forecasts" */}
            {/*         })} */}
            {/*         to="?tab=forecasts"> */}
            {/*         {tab === "forecasts" ? */}
            {/*             <div>{Icons.ForecastsYellow}</div> */}
            {/*             : */}
            {/*             <div>{Icons.ForecastsBlack}</div> */}
            {/*         } */}
            {/*         Prognoosid */}
            {/*     </Link> */}
            {/* </li> */}
            {/* <li> */}
            {/*     <Link */}
            {/*         className={classNames("market-info__navigation-link", { */}
            {/*             "market-info__navigation-link--active": tab === "alert" */}
            {/*         })} */}
            {/*         to="?tab=alert"> */}
            {/*         {tab === "alert" ? */}
            {/*             <div>{Icons.AlertYellow}</div> */}
            {/*             : */}
            {/*             <div>{Icons.AlertBlack}</div> */}
            {/*         } */}
            {/*         Teavitused */}
            {/*     </Link> */}
            {/* </li> */}
          </ul>
        </div>

        <div className="market-info__content">
          {tab === "price-change" && <MarketData />}
          {tab === "forecasts" && <Forecasts />}
          {tab === "alert" && <Alerts />}
        </div>
      </div>
    </>
  );
};

export default MarketInfoPage;
